<template>
	<div class="timeline-container">
		<h2>Geofence Activity Timeline</h2>
		<div v-if="loading" class="loading">Loading...</div>
		<div v-if="error" class="error">{{ error }}</div>
		<ul v-if="groupedActivityData" class="timeline">
			<li v-for="(activities, date) in groupedActivityData" :key="date" class="timeline-day">
				<div @click="toggleDay(date)" class="day-header">
					<span>{{ date }}</span>
				</div>
				<ul v-if="expandedDays[date]" class="hourly-activities">
					<li v-for="activity in activities" :key="activity.dateTime" class="timeline-item">
						<span class="dateTime">{{ formatTime(activity.dateTime) }}</span>
						<span class="description">
							Device {{ activity.device.id }} {{ activity.direction }} the job.
						</span>
					</li>
				</ul>
			</li>
		</ul>
		<div v-if="!activityData.length && !loading" class="no-data">No activity data available.</div>
	</div>
</template>

<script>

export default {
	name: "GeofenceActivityTimeline",
	props: ["job"],
	data() {
		return {
			activityData: [],
			groupedActivityData: {},
			expandedDays: {},
			loading: false,
			error: null,
		};
	},
	methods: {
		fetchActivityData() {
			let vm = this

			let params = {
				lat: vm.job.lat,
				long: vm.job.long,
				radius: vm.job.check_in_tolerance,
				fromDateTime: vm.job.created_at,
				toDateTime: vm.moment().format("YYYY-MM-DD"),
				onlyBoundaryCrossings: true
			}

			vm.getJSON("TrackingDevice/get-geofence-activity",params).then(response => {
				if (response.success) {
					vm.activityData = response.data.flatMap(device => device.log)
					this.groupActivitiesByDay();
				}
			})
		},
		groupActivitiesByDay() {
		  const grouped = this.activityData.reduce((acc, activity) => {
			const date = new Date(activity.dateTime).toLocaleDateString();
			if (!acc[date]) acc[date] = [];
			acc[date].push(activity);
			return acc;
		  }, {});
		  this.groupedActivityData = grouped;
		},
		toggleDay(date) {
		  this.$set(this.expandedDays, date, !this.expandedDays[date]);
		},
		formatTime(dateTime) {
		  const date = new Date(dateTime);
		  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
		},
		},
		mounted() {
			this.fetchActivityData();
		},
};
</script>

<style scoped>
.timeline-container {
  padding: 20px;
  font-family: Arial, sans-serif;
}

.loading {
  font-size: 16px;
  color: #555;
}

.error {
  color: red;
  font-size: 16px;
}

.no-data {
  font-size: 16px;
  color: #555;
}

.timeline {
  list-style-type: none;
  padding: 0;
}

.timeline-day {
  margin: 10px 0;
}

.day-header {
  padding: 10px;
  background: #f0f0f0;
  cursor: pointer;
  border-left: 3px solid #007bff;
}

.day-header:hover {
  background: #e0e0e0;
}

.hourly-activities {
  list-style-type: none;
  padding: 0 0 0 20px;
}

.timeline-item {
  margin: 5px 0;
  padding: 5px;
  border-left: 2px solid #007bff;
  background: #f9f9f9;
  position: relative;
}

.timestamp {
  display: block;
  font-size: 12px;
  color: #888;
}

.description {
  font-size: 14px;
  color: #333;
}
</style>
